import {
   RETRIEVE_PRODUCTDETAILS
} from '../ActionTypes/ActionTypes';


const initialState = {
    productDetails: {}
};
function CommonReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        

        case RETRIEVE_PRODUCTDETAILS:
            return {
                ...state,
                productDetails: payload,
            };

        

        default:
            return {};
    }
};

export default CommonReducer;